// components/shared/ContactUs.jsx
import React from "react";

const ContactUs = () => {
    return (
        <div className="min-h-screen bg-darkblue text-lightgray px-6 py-16">
            <div className="max-w-3xl mx-auto text-center">
                <h1 className="text-4xl font-bold text-orange mb-8">Contact Us</h1>
                <p className="text-lg mb-8">
                    We'd love to hear from you! Whether you have questions, suggestions, or simply want to learn more about Career Mission, feel free to reach out using the options below.
                </p>
                <div className="space-y-6">
                    {/* Email Section */}
                    <div>
                        <h2 className="text-2xl font-semibold text-orange">Email</h2>
                        <p className="text-lg">
                            Send us a message at{" "}
                            <a
                                href="mailto:contact@careermission.ai"
                                className="text-lightblue hover:underline"
                            >
                                contact@careermission.ai
                            </a>
                        </p>
                    </div>
                    {/* LinkedIn Section */}
                    <div>
                        <h2 className="text-2xl font-semibold text-orange">LinkedIn</h2>
                        <p className="text-lg">
                            Connect with us on{" "}
                            <a
                                href="https://www.linkedin.com/company/careermission-ai/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-lightblue hover:underline"
                            >
                                LinkedIn
                            </a>
                        </p>
                    </div>
                    {/* Podcast Section */}
                    <div>
                        <h2 className="text-2xl font-semibold text-orange">Podcast</h2>
                        <p className="text-lg">
                            Listen to our CEO's podcast:{" "}
                            <a
                                href="https://podcasts.apple.com/us/podcast/hiring-humans-person-centered-recruiting-for-the/id1796894844?i=1000693112707"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-lightblue hover:underline"
                            >
                                Hiring Humans: Person-Centered Recruiting
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContactUs;
